import ApiRequest from '../../../Apis/request'

export default class ExtAgApis {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async getExtAgs() {
    try {
      const res = await this.apiRequest.get(`ext_ags_dialog`)
      return res.data
    } catch (error) {
      return error.response
    }
  }
  async CreateExtAgsComments(payload) {
    try {
      const res = await this.apiRequest.post(`ext_ags_comments`, payload)
      return res.data
    } catch (error) {
      return error.response
    }
  }
}
